// 🟢 Redux Action Type Constants
export const FETCH_PRODUCTS_BEGIN = 'FETCH_PRODUCTS_BEGIN' as const;
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS' as const;
export const FETCH_SINGLE_PRODUCT = 'FETCH_SINGLE_PRODUCT' as const;
export const ADD_TO_CART = 'ADD_TO_CART' as const;
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART' as const;
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST' as const;
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST' as const;
export const INCREMENT_QUANTITY = 'INCREMENT_QUANTITY' as const;
export const DECREMENT_QUANTITY = 'DECREMENT_QUANTITY' as const;
export const ADD_TO_COMPARE = 'ADD_TO_COMPARE' as const;
export const REMOVE_FROM_COMPARE_LIST = 'REMOVE_FROM_COMPARE_LIST' as const;

// 🧾 Type Union for all Action Constants
export type ActionTypes =
  | typeof FETCH_PRODUCTS_BEGIN
  | typeof RECEIVE_PRODUCTS
  | typeof FETCH_SINGLE_PRODUCT
  | typeof ADD_TO_CART
  | typeof REMOVE_FROM_CART
  | typeof ADD_TO_WISHLIST
  | typeof REMOVE_FROM_WISHLIST
  | typeof INCREMENT_QUANTITY
  | typeof DECREMENT_QUANTITY
  | typeof ADD_TO_COMPARE
  | typeof REMOVE_FROM_COMPARE_LIST;
